import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var CoinsStacked04 = function CoinsStacked04(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M20 5c0 1.6569-3.5817 3-8 3S4 6.6569 4 5m16 0c0-1.6568-3.5817-3-8-3S4 3.3432 4 5m16 0v14c0 1.6569-3.5817 3-8 3s-8-1.3431-8-3V5m16 4.6666c0 1.6569-3.5817 3-8 3s-8-1.3431-8-3M20 14.33c0 1.6569-3.5817 3-8 3s-8-1.3431-8-3"
    })
  }));
};
export default CoinsStacked04;